module.exports = __webpack_public_path__ + "img/0-38.67791381.jpg";